import React from 'react';
import { styles } from './PerksPromoAlert.css';
import { TextWithLinks } from '../TextWithLinks/TextWithLinks';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';

export type PerksPromoAlertProps = {
  isStickyMobile?: boolean;
  isLoggedIn: boolean;
  isEarlyAccess: boolean;
  isPerksMember: boolean;
  isExclusiveDeal?: boolean;
  isStickyDesktop?: boolean;
  isCouponSurfacingEnabled?: boolean;
  messages?: {
    accountHolderMessage: string;
    guestMessage: string;
    guestEarlyMessage: string;
    accountHolderEarlyMessage: string;
    perksMemberEarlyMessage: string;
    perksCouponsMessage: string;
  };
  onLogin?: () => void;
  b2cBaseUrl?: string;
};

const returnUrl = `/pages/perks?redirect=true&returnUrlOverride=${encodeURIComponent(window.location.href)}`;

const getEarlyAccessMessage = (isPerksMember: boolean, isLoggedIn: boolean, messages?: any) => {
  if (isPerksMember) return messages?.perksMemberEarlyMessage;
  if (isLoggedIn) return messages?.accountHolderEarlyMessage;
  return messages?.guestEarlyMessage;
};

const getMessagingContent = (
  isEarlyAccess: boolean,
  isPerksMember: boolean,
  isLoggedIn: boolean,
  isExclusiveDeal?: boolean,
  isCouponSurfacingEnabled?: boolean,
  messages?: any
) => {
  const defaultIcon = isEarlyAccess ? (
    <Icon name="PerksMegaphoneIllustrated" />
  ) : (
    <Icon name="PerksDiscountIllustrated" />
  );
  if (isExclusiveDeal) {
    if (isLoggedIn && isPerksMember) return;
    return {
      message: isLoggedIn ? messages?.accountHolderMessage : messages?.guestMessage,
      icon: defaultIcon,
    };
  }
  if (isEarlyAccess)
    return {
      message: getEarlyAccessMessage(isPerksMember, isLoggedIn, messages),
      icon: defaultIcon,
    };
  if (!isLoggedIn && isCouponSurfacingEnabled)
    return { message: messages?.perksCouponsMessage, icon: <Icon name="PerksCouponIllustrated" /> };
};

export const PerksPromoAlert = ({
  isStickyMobile,
  messages,
  isLoggedIn,
  isEarlyAccess,
  isPerksMember,
  isExclusiveDeal,
  isStickyDesktop,
  isCouponSurfacingEnabled,
  onLogin,
  b2cBaseUrl,
}: PerksPromoAlertProps) => {
  const messageContent = getMessagingContent(
    isEarlyAccess,
    isPerksMember,
    isLoggedIn,
    isExclusiveDeal,
    isCouponSurfacingEnabled,
    messages
  );

  if (!messageContent) return null;

  let loginUrl = `${b2cBaseUrl}/account/login?pageTheme=perks`;
  loginUrl += `&referrer=${encodeURIComponent(window.location.href)}`;
  loginUrl += `&returnUrl=${encodeURIComponent(returnUrl)}`;

  const replacements = {
    'Log in': loginUrl,
    Join: '/pages/perks?redirect=true',
  };

  return (
    <div className={styles.perksPromoAlert({ isStickyMobile, isStickyDesktop })}>
      <div className={styles.container({ isStickyDesktop })}>
        <div className={isStickyDesktop ? styles.stickyLogo : styles.logo}>{messageContent.icon}</div>
        <TextWithLinks message={messageContent.message} replacements={replacements} onClick={onLogin} />
      </div>
    </div>
  );
};
